import { useEffect } from "react";

export interface IPageTitleProps {
  title: string;
}

export default function PageTitle({ title }: IPageTitleProps) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) {
      document.title = title + " | SEAES HMS";
    } else {
      document.title = import.meta.env.REACT_APP_TITLE || "SEAES HMS";
    }
    return () => {
      document.title = prevTitle;
    };
  }, [title]);

  return <></>;
}
